import { useEffect, useState } from "react";
import api from "../../lib/api";
import { saCard, fmtD } from "../../components/saShared";

export default function SAEventi() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/superadmin/billing-events").then((r) => setList(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="sa-eventi">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Eventi Billing</h1>
        <p className="text-xs text-zinc-500">Log dei webhook Stripe (modalità MOCK — firma non verificata fino al collegamento reale). Idempotenza attiva su event_id.</p>
      </div>
      <div className={`${saCard} divide-y divide-zinc-800/60`} data-testid="sa-events-list">
        {list.length === 0 && <div className="py-10 text-center text-sm text-zinc-500">Nessun evento ricevuto</div>}
        {list.map((e) => (
          <div key={e.id} className="flex items-center gap-3 px-4 py-3 flex-wrap">
            <span className="font-mono text-xs text-zinc-400">{e.event_id || "—"}</span>
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${e.handled ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" : "bg-zinc-700/30 text-zinc-500 border-zinc-600"}`}>
              {e.handled ? "GESTITO" : "IGNORATO"}
            </span>
            <span className="text-sm font-semibold text-zinc-100">{e.type}</span>
            {e.mock && <span className="text-[9px] font-bold text-zinc-500 border border-zinc-700 rounded-full px-1.5 py-0.5">MOCK</span>}
            <span className="text-xs text-zinc-500 ml-auto">{fmtD(e.received_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
